import { render, staticRenderFns } from "./CreateFishery.vue?vue&type=template&id=8fdfdc94&scoped=true&"
import script from "./CreateFishery.vue?vue&type=script&lang=js&"
export * from "./CreateFishery.vue?vue&type=script&lang=js&"
import style0 from "./CreateFishery.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./CreateFishery.vue?vue&type=style&index=1&id=8fdfdc94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdfdc94",
  null
  
)

export default component.exports